// ==================================================================================================
//
// Form Validation
//
// ==================================================================================================
import { forEach } from 'lodash'
import I18n from '../i18n';
I18n;

const formValidation = () => {
  let props = {
    skipValidation: false,
    phoneFieldIsValid: false,
    ccExpFieldIsValid: false
  };

  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$form = $('.js-form-validate')

    els.$phoneNumberFields = $('input[data-parsley-group="phone_number"]')
    els.$phoneNumberFieldLabel = $('.js-phone-number-field').find('.form__input-label')

    els.$ccExpirationFields = $('input[data-parsley-group="expiration"]')
    els.$ccExpirationFieldLabel = $('.js-expiration-field').find('.form__input-label')
  }

  // Run parsley configuration for error location
  // ------------------------------------------------
  const runParsleyConfig = () => {
    let parsleyConfig = {
      errorsContainer: function(error) {
        let errElem = error.$element

        // if select, move up dom tree to place error next to label
        if (errElem.parents('.select-container').length != 0) {
          return errElem.parents('.select-container').siblings('.form__input-label-group')

        // otherwise, place inside label group
        } else {
          return errElem.siblings('.form__input-label-group')
        }
      }
    }

    els.$form.parsley(parsleyConfig);
  }

  // Special validations for required groups
  // ------------------------------------------------
  const validateGroupFields = (fieldGroup, fieldGroupLabel, fieldGroupProp, customValidator) => {
    const inputs = $.map(fieldGroup, (el) => { return el.value }) // return `input` values

    // add error based on values of all three fields
    if ((inputs.includes("")) && (fieldGroupLabel.siblings('.parsley-errors-list').children().length === 0)) {
      fieldGroupLabel.parsley().addError(customValidator, { message: I18n.t("valid_value") }); // add the error
      fieldGroupProp = false

    } else if ((!inputs.includes("")) && (!fieldGroup.hasClass('parsley-error'))) {
      fieldGroupLabel.parsley().removeError(customValidator, { message: I18n.t("valid_value") }); // remove the error
      fieldGroupProp = true
    }

    // add error class to affected fields
    fieldGroup.each(function() {
      // if any of the 3 fields are empty and an error doesn't already exist
      if ($(this).val() === '') {
        $(this).addClass('parsley-error') // add error class to each affected input
      }
    })
  }

  // Add focus to first error
  // ------------------------------------------------
  const focusOnFirstError = () => {
    const $firstErrorInput = els.$form.find('.parsley-error:first')

    if (els.$form.find('.parsley-errors-list').length) {
      const topOffset = els.$form.find('.parsley-errors-list:first').offset().top - 5

      $('html, body').animate({
        scrollTop: topOffset
      }, 250, () => {
        $firstErrorInput.focus()
      });
    }
  }

  // Stop submission if special groups don't pass validation
  // ------------------------------------------------
  const stopSubmitIfGroupValidationsFail = (e, groupName) => {
    const specialFieldIsValid = e.isValid({ group: groupName, force: true })

    // don't submit form until special group is valid
    if (!specialFieldIsValid) {
      e.validationResult = false
    } else {
      e.trigger('submit', false)
    }
  }

  // Run validations and / or submit
  // ------------------------------------------------
  const validateForm = (runValidations, e) => {
    if (!runValidations) {
      e.preventDefault()
      return
    }

    // run special group validations on phone number fields if they exist
    if (els.$phoneNumberFields.length) {
      validateGroupFields(els.$phoneNumberFields, els.$phoneNumberFieldLabel, props.phoneFieldIsValid, 'phoneFieldValidator');
      stopSubmitIfGroupValidationsFail(e, 'phone_number')
    }

    // run special group validations on cc expiration fields if they exist
    if (els.$ccExpirationFields.length) {
      if(els.$ccExpirationFields[0].ariaRequired === 'true'){
        validateGroupFields(els.$ccExpirationFields, els.$ccExpirationFieldLabel, props.ccExpFieldIsValid, 'ccExpFieldValidator');
        stopSubmitIfGroupValidationsFail(e, 'expiration')
      }
    }

    if (!els.$form.parsley().isValid()) {
      toggleErrorsToInvalid()
      focusOnFirstError()
    } else {
      // If newPaymentForm trigger event to show notification (which disable button click)
      if (els.$form.hasClass("newPaymentForm")) global.dispatchEvent(new CustomEvent('validation:finished',{ detail: "newPaymentForm" }))
    }

  }

  // Toggle aria-invalid so screenreader sees invalidity
  // ------------------------------------------------
  const toggleErrorsToInvalid = () => {
    if ($('.parsley-errors-list').length) {
      hideInlineErrorsFromAria()
      $('.parsley-errors-list').each(function() {
        $(this).parents('.form__input-label-group').siblings('.parsley-error').attr('aria-invalid', 'true')
      })
    }
  }

  // Hide Parsley errors from screenreaders
  // ------------------------------------------------
  const hideInlineErrorsFromAria = () => {
    $('.parsley-errors-list').each(function() {
      $(this).attr('aria-hidden', 'true')
    })
  }

  // On load, check if formwide errors exist
  // if so, set aria to read error first
  // ------------------------------------------------
  const checkForFormwideErrors = () => {
    if ($('.flash-error-message').length) $('.js-form-error').focus()
    if ($('#error_explanation').length) $('.js-form-error').focus()
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    runParsleyConfig()
    checkForFormwideErrors()

    if (els.$phoneNumberFields.length) {
      forEach(els.$phoneNumberFields, phoneField => {
        phoneField.addEventListener(
          'focusout',
          validateGroupFields.bind(null, els.$phoneNumberFields, els.$phoneNumberFieldLabel, props.phoneFieldIsValid, 'phoneFieldValidator')
        )
      })
    }

    if (els.$ccExpirationFields.length) {
      forEach(els.$ccExpirationFields, ccExpField => {
        ccExpField.addEventListener(
          'focusout',
          validateGroupFields.bind(null, els.$ccExpirationFields, els.$ccExpirationFieldLabel, props.ccExpFieldIsValid, 'ccExpFieldValidator')
        )
      })
    }

    window.Parsley.on('field:error', hideInlineErrorsFromAria);
    window.Parsley.on('form:validated', validateForm.bind(null, true));

    props.isEnabled = true;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    if (els.$phoneNumberFields.length) {
      forEach(els.$phoneNumberFields, phoneField => {
        phoneField.removeEventListener(
          'focusout',
          validateGroupFields.bind(null, els.$phoneNumberFields, els.$phoneNumberFieldLabel, props.phoneFieldIsValid, 'phoneFieldValidator')
        )
      })
    }

    if (els.$ccExpirationFields.length) {
      forEach(els.$ccExpirationFields, ccExpField => {
        ccExpField.removeEventListener(
          'focusout',
          validateGroupFields.bind(null, els.$ccExpirationFields, els.$ccExpirationFieldLabel, props.ccExpFieldIsValid, 'ccExpFieldValidator')
        )
      })
    }

    window.Parsley.off('field:error', hideInlineErrorsFromAria);
    window.Parsley.off('form:validated', validateForm.bind(null, true));

    props.isEnabled = false;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren()
    enable()
  }

  return {
    init,
    enable,
    disable
  };
}

export default formValidation;
